import { ReduxSagaActionSubtypes } from '@/types';

import { ApiRequestsReducerState } from './types';

export enum RequestType {
  ADVANCED = 'ADVANCED',
}

export const STATUS: ReduxSagaActionSubtypes = {
  START: 'start',
  STOP: 'stop',
  FAIL: 'fail',
  SUCCESS: 'success',
  CLEAN_UP: 'cleanUp',
};

export const initialState: ApiRequestsReducerState = {
  statuses: {},
  errors: {},
};
